var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "saas-cgu px-2 pt-2 pb-0" },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c(
        "header",
        { staticClass: "header px-1 flex-column mb-3" },
        [
          _c("SaasIcon", {
            staticClass: "logo secondary-blue",
            attrs: { icon: "svgLogoSellsyText", width: 118, height: 28 }
          }),
          _vm._v(" "),
          _vm.areAccepted && !_vm.isEmbed
            ? _c(
                "a",
                {
                  staticClass: "back-link grey-link semibold fs-3 flex-level",
                  attrs: { href: "/" }
                },
                [
                  _c("i", { staticClass: "el-icon-arrow-left semibold" }),
                  _vm._v(_vm._s(_vm.$l10n.__("Retour")))
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container m-auto" }, [
        _c("h1", { class: { "mb-5": !_vm.areAccepted } }, [
          _vm._v(_vm._s(_vm.termsTitle))
        ]),
        _vm._v(" "),
        _vm.acceptanceDate && _vm.terms.acceptor
          ? _c("h4", { staticClass: "regular alert alert-info mb-5" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("capitalize")(
                      _vm.$l10n.__(
                        "acceptées le %(date)s par %(name)s (%(email)s)",
                        {
                          date: _vm.acceptanceDateFormatted,
                          name: _vm.terms.acceptor.name,
                          email: _vm.terms.acceptor.email
                        }
                      )
                    )
                  ) +
                  "\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.terms.url
          ? _c("embed", {
              staticClass: "pdf-embed",
              class: { "cgu-accepted": _vm.areAccepted },
              attrs: { src: "" + _vm.terms.url, type: "application/pdf" }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.areAccepted
        ? _c("fixed-footer", [
            _c(
              "div",
              { staticClass: "flex-level jc-center" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.terms_checked,
                      callback: function($$v) {
                        _vm.terms_checked = $$v
                      },
                      expression: "terms_checked"
                    }
                  },
                  [
                    _vm._t("checkbox", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "En cochant cette case, je reconnais avoir pris connaissance des %(terms_name)s de Sellsy et je les accepte.",
                              { terms_name: _vm.termsTitle }
                            )
                          ) +
                          "\n                "
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-5",
                  attrs: {
                    label: _vm.getContentButton,
                    disabled: !_vm.terms_checked
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.terms_checked ? _vm.accept() : ""
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }